/* eslint-disable */

import Vue from 'vue';
import VueObserveVisibility from 'vue-observe-visibility';
import app from '../app/components/app.vue';

var map = new Vue({
  el: '#c-map',
  render: h => h(app)
});


// WEBPACK FOOTER //
// ./scripts/app.js